import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { RevealText } from './shared';

const STATS = [
  { value: '35+', label: 'Years of leather expertise' },
  { value: '5,000+', label: 'Leather garments produced monthly' },
  { value: '50+', label: 'Skilled production professionals' },
  { value: 'Global', label: 'Serving international markets & brands' },
];

export default function AboutIntro() {
  return (
    <section
      id="about-intro"
      data-testid="about-intro"
      className="relative bg-[#0A0A0A] px-6 md:px-16 py-28 md:py-40 border-t border-[#2A2A2A] overflow-hidden"
    >
      <div className="max-w-3xl">
        <motion.span
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="font-accent text-[10px] text-[#8C5A35] block mb-6"
        >
          About PTExports
        </motion.span>

        <RevealText className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight mb-8">
          Crafting Leather.<br /><span className="italic text-[#B89B72]">Building Legacies.</span>
        </RevealText>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="font-body font-light text-sm md:text-base text-[#A3A3A3] leading-relaxed max-w-xl"
        >
          For over 35 years, PTExports has been dedicated to the art and precision of leather
          manufacturing. Founded on a commitment to craftsmanship and responsible production, we have
          grown into a trusted partner for international brands — producing premium leather garments,
          footwear and products from our manufacturing base in India.
        </motion.p>

        <Link
          to="/about"
          data-testid="about-know-more"
          data-hover
          className="group inline-flex items-center gap-3 border border-[#B89B72]/60 text-[#B89B72] px-8 py-4 mt-10 font-accent text-[10px] hover:bg-[#8C5A35]/20 transition-colors duration-300"
        >
          Know More
          <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.2} />
        </Link>
      </div>

      {/* Stat strip */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[#2A2A2A] border border-[#2A2A2A] mt-20 md:mt-28">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className="bg-[#0A0A0A] px-6 py-8 md:py-10"
          >
            <div className="font-display text-3xl md:text-4xl text-[#B89B72] font-light">{s.value}</div>
            <div className="font-body font-light text-[11px] md:text-xs text-[#A3A3A3] mt-2 leading-relaxed">{s.label}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
